<script>
export default {
  data() {
    return {
      imageModalShow: false,
      videoModalShow: false,
      image: "",
      previous: null,
      next: null,
      video: "",
      videoPrevious: null,
      videoNext: null,
      imageIndex: null,
    };
  },

  props: ["images", "videos"],
  mounted() {
    let self = this;
    window.addEventListener("keydown", (e) => {
      if (e.key == "ArrowRight") {
        self.nextImage();
      } else if (e.key == "ArrowLeft") {
        self.previousImage();
      }
    });
  },
  methods: {
    setImageIndexes(index) {
      this.image = this.images[index];
      this.previous = index > 0 ? index - 1 : null;
      this.next = index < this.images.length - 1 ? index + 1 : null;
      this.imageIndex = index;
    },
    previousImage() {
      if (this.previous == null) {
        return;
      }
      this.setImageIndexes(this.previous);
    },
    nextImage() {
      if (this.next == null) {
        return;
      }
      this.setImageIndexes(this.next);
    },
    openImageModal(index) {
      this.setImageIndexes(index);
      this.imageModalShow = true;
    },
    openPdf(index) {
      var pdf = this.images[index];
      window.open(pdf.file_url, "_blank");
    },
    closeImageModal() {
      this.imageModalShow = false;
      this.image = "";
      this.previous = null;
      this.next = null;
    },

    openVideoModal(index) {
      this.setVideoIndexes(index);
      this.videoModalShow = true;
    },
    closeVideoModal() {
      this.videoModalShow = false;
      this.video = "";
      this.videoPrevious = null;
      this.videoNext = null;
    },
    setVideoIndexes(index) {
      this.video = this.videos[index];
      this.videoPrevious = index > 0 ? index - 1 : null;
      this.videoNext = index < this.videos.length - 1 ? index + 1 : null;
    },
    previousVideo() {
      if (this.videoPrevious == null) {
        return;
      }
      this.setVideoIndexes(this.videoPrevious);
    },
    nextVideo() {
      if (this.videoNext == null) {
        return;
      }
      this.setVideoIndexes(this.videoNext);
    },
  },
};
</script>
